import { ReactNode } from "react";
import { Box, Flex, SystemProps, Text } from "@storyofams/react-ui";
import { convertCSStoObject, replaceVariables } from "~/context/helper";
import { useFlow, useSession } from "~/hooks";

import { useIsRtl } from "~/hooks";
import { Check } from "../Check";
import { OptionProps } from "../Options/Option";

interface OptionChoiceProps extends Pick<OptionProps, "type"> {
  checked: boolean;
  right?: ReactNode;
  title: string;
  subtext?: string;
}

export const OptionChoice = ({ checked, right, title, subtext, ...props }: OptionChoiceProps & SystemProps) => {
  const isRtl = useIsRtl();
  const { flow } = useFlow();
  const { session } = useSession();
  const sessionVariables = session?.answers ? JSON.parse(session?.answers) : {};

  return (
    <>
      <Flex flex="1" flexDirection="row" alignItems="center" className="answer-container">
        <Check type={props.type} isActive={checked} className="answer-checkbox" />

        <Box
          width="100%"
          minWidth="0"
          maxWidth="100%"
          className="answer-text-container"
          css={{
            marginInlineStart: "12px",
          }}
        >
          <Text
            fontSize={2.25}
            letterSpacing={isRtl ? undefined : "-0.01em"}
            lineHeight="22px"
            color="black90"
            className="answer-text"
            style={convertCSStoObject(flow?.cssEditor)[".answer-text"]}
          >
            <div dangerouslySetInnerHTML={{ __html: replaceVariables(title, sessionVariables) ?? title }} style={{ position: "relative", zIndex: "2" }} />
          </Text>
          {!!subtext && (
            <Text
              mt={0.25}
              fontSize={1.5}
              letterSpacing={isRtl ? undefined : "-0.01em"}
              lineHeight="15px"
              color="black60"
              className="answer-description"
              style={convertCSStoObject(flow?.cssEditor)[".answer-description"]}
            >
              <div dangerouslySetInnerHTML={{ __html: replaceVariables(subtext, sessionVariables) ?? subtext }} style={{ position: "relative", zIndex: "2" }} />
            </Text>
          )}
        </Box>
      </Flex>

      {!!right && (
        <Box width="48px" height="48px" lineHeight="48px" display="inline-flex" alignItems="center" justifyContent="center">
          {right}
        </Box>
      )}
    </>
  );
};
